import { combineReducers, createStore } from "redux";
import { Reducer as auth } from "./Auth/Auth";

const rootReducer = combineReducers({
  auth,
});

export type AppState = ReturnType<typeof rootReducer>;

export default createStore(rootReducer);
